import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import Reveal from "@/components/site/Reveal";
import { IMAGES } from "@/lib/siteData";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-ink">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 border border-line" aria-hidden="true" />
              <div className="relative overflow-hidden">
                <motion.img
                  initial={{ scale: 1.15 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                  src={IMAGES.about}
                  alt="Newly remodeled home interior by B3 Contracting"
                  className="w-full h-[420px] lg:h-[520px] object-cover"
                />
              </div>
              <div className="absolute bottom-5 left-5 bg-gold text-ink px-6 py-4">
                <p className="font-heading font-bold text-2xl leading-none">10+</p>
                <p className="text-xs uppercase tracking-wider mt-1">Services under one roof</p>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">B3 Contracting LLC</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading font-bold tracking-tight text-white text-4xl sm:text-5xl leading-[1.05]">
                One contractor. <br />
                <span className="text-white/50">A wide range of services.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-base sm:text-lg text-white/70 leading-relaxed max-w-xl">
                Whether you're planning a remodel, need a new fence, want to refresh your home with
                paint, or need help improving your property, B3 Contracting LLC is here to help. We
                focus on dependable service, clear communication and quality results.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <a
                href="#contact"
                data-testid="about-project-link"
                className="group mt-9 inline-flex items-center gap-2 text-gold font-semibold hover:text-gold-hover transition-colors"
              >
                Tell us about your project
                <ArrowRight size={18} weight="bold" className="transition-transform duration-200 group-hover:translate-x-1" />
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
